import React, { Suspense, useEffect, useState, useContext } from 'react';
import { BrowserRouter as Router, Route, Redirect, useHistory } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Loggedincontext } from './Loggedincontext.js';
import { Routedispatcherprovider } from './Routedispatcher';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import './components/Website/Generalfiles/CSS_GENERAL/bootstrap.css';
import './trans.css';
import './components/Website/crm-pages.css';

import { Contexthandlerscontext_provider } from './Contexthandlerscontext';
import Preloader from './components/Website/Preloader';

const Websiterouter = React.lazy(() => import('./components/Website/Websiterouter'));
const Login = React.lazy(() => import('./components/Website/Login/Login'));
const Clientapproval = React.lazy(() => import('./components/Website/Clientapproval/Clientapproval'));
const ClientapprovalKSA = React.lazy(() => import('./components/Website/Clientapproval/ClientapprovalKSA'));
const Contract = React.lazy(() => import('./components/Website/Clientapproval/Contract'));
const Rating = React.lazy(() => import('./components/Website/Clientapproval/Rating'));
const SupportRating = React.lazy(() => import('./components/Website/Clientapproval/SupportRating'));
const JSONFile = React.lazy(() => import('./components/Website/UploadJson/JSONFile'));
const BuildLogs = React.lazy(() => import('./components/Website/UploadJson/BuildLogs'));

const App = () => {
    const history = useHistory();
    const { fetchuseauthorizationQueryContext } = useContext(Loggedincontext);

    /* ❄ SNOW STATE */
    const SNOW_CHARS = ['❆', '❅', '•', '*', '·'];
    const FLAKE_COUNT = 80;

    const [flakes] = useState(() =>
        Array.from({ length: FLAKE_COUNT }).map(() => ({
            id: Math.random(),
            left: Math.random() * 100,
            top: Math.random() * 100,
            size: Math.random() * 14 + 10,
            duration: Math.random() * 15 + 10,
            delay: 0,
            char: SNOW_CHARS[Math.floor(Math.random() * SNOW_CHARS.length)],
        })),
    );

    /* ⏳ LOADING SCREEN */
    if (fetchuseauthorizationQueryContext.isFetching) {
        return <Preloader />;
    }

    return (
        <Contexthandlerscontext_provider>
            <Router>
                <Routedispatcherprovider>
                    <div style={{ height: '100%', width: '100%', background: 'var(--white)' }}>
                        {/* ❄ SNOW LAYER */}
                        {/* <div
                            style={{
                                position: 'fixed',
                                inset: 0,
                                pointerEvents: 'none',
                                overflow: 'hidden',
                                zIndex: 999999,
                            }}
                        >
                            {flakes.map((f) => (
                                <span
                                    key={f.id}
                                    className="snowflake"
                                    style={{
                                        left: `${f.left}%`,
                                        fontSize: `${f.size}px`,
                                        animationDuration: `${f.duration}s`,
                                        color: '#D3FFFF',
                                    }}
                                >
                                    {f.char}
                                </span>
                            ))}
                        </div> */}

                        {/* 🌐 ROUTES */}
                        <Suspense fallback={<Preloader label="Loading the page" />}>
                            <Route exact path="/" render={() => (fetchuseauthorizationQueryContext?.data?.data?.loggedin ? <Redirect to="/home" /> : <Redirect to="/login" />)} />

                            {fetchuseauthorizationQueryContext?.data?.data?.loggedin ? (
                                <Websiterouter />
                            ) : (
                                <>
                                    <Route exact path="/login" component={Login} />
                                    <Route exact path="/clientapproval/:typeparam/:dealidparam" component={Clientapproval} />
                                    <Route exact path="/clientapprovalksa/:typeparam/:dealidparam" component={ClientapprovalKSA} />
                                    <Route exact path="/jsonfile" component={JSONFile} />
                                    <Route exact path="/contract" component={Contract} />
                                    <Route exact path="/rating" component={Rating} />
                                    <Route exact path="/supportrating" component={SupportRating} />

                                    <Route exact path="/buildlogs" component={BuildLogs} />
                                </>
                            )}
                        </Suspense>
                    </div>
                </Routedispatcherprovider>
            </Router>

            <NotificationContainer />
            <ReactQueryDevtools initialIsOpen={false} />
        </Contexthandlerscontext_provider>
    );
};

export default App;
